/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type EventTeamQueryVariables = {
    orgRelayId: string;
    eventParentRelayId: string;
    calendarId: string;
};
export type EventTeamQueryResponse = {
    readonly viewer: {
        readonly user: {
            readonly " $fragmentRefs": FragmentRefs<"EventTeam_user">;
        } | null;
    };
    readonly org: {
        readonly " $fragmentRefs": FragmentRefs<"EventTeam_org">;
    } | null;
    readonly eventParent: {
        readonly " $fragmentRefs": FragmentRefs<"EventTeam_eventParent">;
    } | null;
};
export type EventTeamQuery = {
    readonly response: EventTeamQueryResponse;
    readonly variables: EventTeamQueryVariables;
};



/*
query EventTeamQuery(
  $orgRelayId: ID!
  $eventParentRelayId: ID!
  $calendarId: String!
) {
  viewer {
    user {
      ...EventTeam_user
      id
    }
    id
  }
  org: node(id: $orgRelayId) {
    __typename
    ... on Org {
      ...EventTeam_org
    }
    id
  }
  eventParent: node(id: $eventParentRelayId) {
    __typename
    ... on EventParent {
      ...EventTeam_eventParent_3GsBW
    }
    id
  }
}

fragment AutopilotFlexibility_event on Event {
  eventParentRelayId
  attendeePeople {
    __typename
    ... on PersonList {
      list {
        id
        emails
        primaryEmail
        profile {
          givenName
          familyName
          externalImageUrl
        }
        isYou
      }
    }
  }
  eventKey {
    id
    externalEventId
  }
  annotatedEvent {
    orgTags {
      tag
      state {
        active
        value
        subjectType
        subjectValue
        lastModified
      }
    }
    id
  }
  annotatedRecurringEvent {
    orgTags {
      tag
      state {
        active
        value
        subjectType
        subjectValue
        lastModified
      }
    }
    id
  }
  suggestedAutopilotSettingsResponseV3 {
    __typename
    ... on SuggestedAutopilotSettingsResponseV3 {
      intersectionOfAttendeesMeetingHours {
        minSlot {
          dayOffset
          timeSlot
        }
        maxSlot {
          dayOffset
          timeSlot
        }
      }
      calendarIdToMeetingHours {
        calendarId
        dayOffsetTimeSlotRanges {
          minSlot {
            dayOffset
            timeSlot
          }
          maxSlot {
            dayOffset
            timeSlot
          }
        }
      }
      suggestedAutopilotSettings {
        isRoomFlexible
        movementType
        allowedEndTime {
          dayOffset
          timeSlot
        }
        allowedStartTime {
          dayOffset
          timeSlot
        }
      }
    }
    ... on GraphEntityError {
      message
    }
  }
  moveRangeInLocalTimeV3 {
    __typename
    ... on MoveRangeInLocalTimeV3 {
      allowedStartTimeInclusive {
        dayOffset
        timeSlot
      }
      allowedEndTimeInclusive {
        dayOffset
        timeSlot
      }
    }
    ... on GraphEntityError {
      message
    }
  }
}

fragment AutopilotFormSaveOnEdit_event_3GsBW on Event {
  ...AutopilotForm_event_3GsBW
  title
  isAllDay
  locked
  eventKey {
    externalEventId
    id
  }
  autopilotEventStatus(calendarId: $calendarId) {
    __typename
    ... on AutopilotEventStatus {
      status
    }
  }
  startTime {
    dateOrDateTime
    millis
  }
  organizer {
    urnValue
  }
  attendees {
    displayName
    urnValue
  }
  annotatedEvent {
    orgTags {
      tag
      state {
        active
        value
        subjectType
        subjectValue
        lastModified
      }
    }
    id
  }
  annotatedRecurringEvent {
    orgTags {
      tag
      state {
        active
        value
        subjectType
        subjectValue
        lastModified
      }
    }
    id
  }
  attendeePeople {
    __typename
    ... on PersonList {
      list {
        id
        emails
        primaryEmail
        profile {
          givenName
          familyName
          externalImageUrl
        }
        isYou
      }
    }
  }
  suggestedAutopilotSettingsResponseV3 {
    __typename
    ... on SuggestedAutopilotSettingsResponseV3 {
      intersectionOfAttendeesMeetingHours {
        minSlot {
          dayOffset
          timeSlot
        }
        maxSlot {
          dayOffset
          timeSlot
        }
      }
      calendarIdToMeetingHours {
        calendarId
        dayOffsetTimeSlotRanges {
          minSlot {
            dayOffset
            timeSlot
          }
          maxSlot {
            dayOffset
            timeSlot
          }
        }
      }
      suggestedAutopilotSettings {
        isRoomFlexible
        movementType
        allowedEndTime {
          dayOffset
          timeSlot
        }
        allowedStartTime {
          dayOffset
          timeSlot
        }
      }
    }
    ... on GraphEntityError {
      message
    }
  }
  moveRangeInLocalTimeV3 {
    __typename
    ... on MoveRangeInLocalTimeV3 {
      allowedStartTimeInclusive {
        dayOffset
        timeSlot
      }
      allowedEndTimeInclusive {
        dayOffset
        timeSlot
      }
    }
    ... on GraphEntityError {
      message
    }
  }
}

fragment AutopilotForm_event_3GsBW on Event {
  ...AutopilotFlexibility_event
  ...OrganizerAutopilotPausedFreemiumCallout_event
  eventParentRelayId
  eventKey {
    id
    externalEventId
  }
  autopilotEventStatus(calendarId: $calendarId) {
    __typename
    ... on AutopilotEventStatus {
      status
    }
  }
  annotatedEvent {
    orgTags {
      tag
      state {
        active
        value
        subjectType
        subjectValue
        lastModified
      }
    }
    id
  }
  annotatedRecurringEvent {
    orgTags {
      tag
      state {
        active
        value
        subjectType
        subjectValue
        lastModified
      }
    }
    id
  }
  suggestedAutopilotSettingsResponseV3 {
    __typename
    ... on SuggestedAutopilotSettingsResponseV3 {
      intersectionOfAttendeesMeetingHours {
        minSlot {
          dayOffset
          timeSlot
        }
        maxSlot {
          dayOffset
          timeSlot
        }
      }
      calendarIdToMeetingHours {
        calendarId
        dayOffsetTimeSlotRanges {
          minSlot {
            dayOffset
            timeSlot
          }
          maxSlot {
            dayOffset
            timeSlot
          }
        }
      }
      suggestedAutopilotSettings {
        isRoomFlexible
        movementType
        allowedEndTime {
          dayOffset
          timeSlot
        }
        allowedStartTime {
          dayOffset
          timeSlot
        }
      }
    }
    ... on GraphEntityError {
      message
    }
  }
  moveRangeInLocalTimeV3 {
    __typename
    ... on MoveRangeInLocalTimeV3 {
      allowedStartTimeInclusive {
        dayOffset
        timeSlot
      }
      allowedEndTimeInclusive {
        dayOffset
        timeSlot
      }
    }
    ... on GraphEntityError {
      message
    }
  }
  featureStatesForOrganizer {
    __typename
    ... on FeatureStates {
      mixedFreemiumOrgUIState {
        autopilotPaused
        moveRangesEnabled
      }
    }
    ... on GraphEntityError {
      statusCode
      message
    }
  }
}

fragment EventPeople_event on Event {
  organizer {
    urnValue
  }
  attendees {
    organizer
    urnValue
    responseStatus
  }
  attendeePeople {
    __typename
    ... on PersonList {
      list {
        __typename
        id
        emails
        primaryEmail
        isYou
        userId
        isUser
        profile {
          givenName
          familyName
          externalImageUrl
        }
      }
    }
  }
}

fragment EventSmartHoldInfo_event_3GsBW on Event {
  ...EventSummary_event_3GsBW
  title
  isClockwiseEvent
  organizer {
    urnValue
  }
  eventKey {
    externalEventId
    id
  }
  annotatedEvent {
    orgTags {
      tag
      state {
        subjectType
        subjectValue
        value
        active
      }
    }
    id
  }
  startTime {
    type
    dateOrDateTime
    timeZone
    millis
    offsetMinutes
  }
  endTime {
    type
    dateOrDateTime
    timeZone
    millis
    offsetMinutes
  }
}

fragment EventSummaryAutopilot_event_3GsBW on Event {
  autopilotEventStatus(calendarId: $calendarId) {
    __typename
    ... on AutopilotEventStatus {
      status
    }
  }
  annotatedEvent {
    orgTags {
      tag
      state {
        active
        value
        subjectType
      }
    }
    id
  }
  annotatedRecurringEvent {
    orgTags {
      tag
      state {
        active
        value
        subjectType
      }
    }
    id
  }
  featureStatesForOrganizer {
    __typename
    ... on FeatureStates {
      mixedFreemiumOrgUIState {
        autopilotPaused
        moveRangesEnabled
      }
    }
    ... on GraphEntityError {
      statusCode
      message
    }
  }
}

fragment EventSummaryColorCategory_event on Event {
  title
  isClockwiseEvent
  transparency
  isAllDay
  eventKey {
    id
    externalEventId
    orgId
  }
  annotatedEvent {
    userTags {
      tag
      states {
        value
        subjectType
        subjectValue
        lastModified
        active
      }
    }
    orgTags {
      tag
      state {
        value
        subjectType
        subjectValue
        lastModified
        active
      }
    }
    id
  }
}

fragment EventSummaryRecurrence_event on Event {
  isAllDay
  startTime {
    type
    dateOrDateTime
    timeZone
    millis
    offsetMinutes
  }
  endTime {
    type
    dateOrDateTime
    timeZone
    millis
    offsetMinutes
  }
  eventKey {
    externalEventId
    id
  }
  eventFlexibilityErrorable {
    __typename
    ... on EventFlexibilityNewList {
      list {
        flex
        flexString
      }
    }
  }
  recurrenceRules {
    firstInstanceStartTime {
      type
      dateOrDateTime
      timeZone
      millis
      offsetMinutes
    }
    timeZone
    interval {
      interval
      byDay
      bySetPos
      freqType
      count
      untilTime {
        type
        dateOrDateTime
        timeZone
        millis
        offsetMinutes
      }
    }
  }
  annotatedEvent {
    orgTags {
      tag
      state {
        active
        value
        subjectType
      }
    }
    id
  }
}

fragment EventSummaryRoom_attendees on Attendee {
  displayName
  urnValue
}

fragment EventSummaryTime_event on Event {
  startTime {
    type
    dateOrDateTime
    timeZone
    millis
    offsetMinutes
  }
  endTime {
    type
    dateOrDateTime
    timeZone
    millis
    offsetMinutes
  }
  eventKey {
    externalEventId
    id
  }
  eventFlexibilityErrorable {
    __typename
    ... on EventFlexibilityNewList {
      list {
        flex
        flexString
      }
    }
  }
  recurrenceRules {
    firstInstanceStartTime {
      type
      dateOrDateTime
      timeZone
      millis
      offsetMinutes
    }
    timeZone
    interval {
      interval
      byDay
      bySetPos
      freqType
      count
      untilTime {
        type
        dateOrDateTime
        timeZone
        millis
        offsetMinutes
      }
    }
  }
  annotatedEvent {
    orgTags {
      tag
      state {
        active
        value
        subjectType
      }
    }
    id
  }
}

fragment EventSummaryTime_org on Org {
  id
  primaryOrgCalendar
}

fragment EventSummary_event_3GsBW on Event {
  ...EventSummaryColorCategory_event
  ...EventSummaryRecurrence_event
  ...EventSummaryTime_event
  ...EventSummaryAutopilot_event_3GsBW
  ...EventTimeAndRecurrence_event
  ...AutopilotFormSaveOnEdit_event_3GsBW
  title
  isAllDay
  description
  descriptionOmitted
  locked
  isClockwiseEvent
  createdMillis
  updatedMillis
  hangoutLink
  scrubbedEvent
  organizer {
    urnValue
  }
  eventKey {
    externalEventId
    id
  }
  annotatedEvent {
    orgTags {
      tag
      state {
        subjectType
        subjectValue
        value
        active
      }
    }
    id
  }
  attendees {
    ...EventSummaryRoom_attendees
    organizer
    displayName
    urnValue
  }
  startTime {
    millis
  }
  endTime {
    millis
  }
  recurrenceRules {
    firstInstanceStartTime {
      type
      dateOrDateTime
      timeZone
      millis
      offsetMinutes
    }
    timeZone
    interval {
      interval
      byDay
      bySetPos
      freqType
      count
      untilTime {
        type
        dateOrDateTime
        timeZone
        millis
        offsetMinutes
      }
    }
  }
}

fragment EventTeam_eventParent_3GsBW on EventParent {
  id
  externalEventId
  events {
    ...AutopilotFormSaveOnEdit_event_3GsBW
    ...EventSummary_event_3GsBW
    ...EventSmartHoldInfo_event_3GsBW
    ...EventPeople_event
    ...EventSummaryTime_event
    calendarIds
    isAllDay
    isClockwiseEvent
    locked
    organizerPerson {
      __typename
      ... on Person {
        emails
      }
      ... on Node {
        __isNode: __typename
        id
      }
    }
    annotatedEvent {
      userTags {
        tag
        states {
          value
          subjectType
          subjectValue
          lastModified
          active
        }
      }
      orgTags {
        tag
        state {
          subjectType
          subjectValue
          value
          active
        }
      }
      id
    }
    eventKey {
      id
      calendarIds
      externalEventId
      hashedCalendars
      orgId
    }
    startTime {
      millis
      dateOrDateTime
      timeZone
    }
    endTime {
      millis
    }
    title
    attendees {
      displayName
      urnValue
    }
    organizer {
      urnValue
    }
  }
}

fragment EventTeam_org on Org {
  id
  ...EventSummaryTime_org
  experiments
  domains
  primaryOrgCalendar
  userTeams {
    __typename
    ... on TeamList {
      list {
        id
        teamId
        teamCalendarId
        teamName
        createdBy {
          value
          id
        }
        teamMembers {
          person {
            __typename
            id
            primaryCalendarId
            isYou
            userId
            profile {
              givenName
              familyName
              externalImageUrl
            }
          }
        }
        invitedMembers {
          person {
            __typename
            id
            primaryCalendarId
            isYou
            userId
            profile {
              givenName
              familyName
              externalImageUrl
            }
          }
        }
        settings {
          __typename
          ... on TeamSettings {
            manageTeamCalendar
          }
          ... on Node {
            __isNode: __typename
            id
          }
        }
      }
    }
  }
}

fragment EventTeam_user on User {
  chromeExtensionFlagsErrorable {
    __typename
    ...TutorialTeamSharedCalendar_flagsErrorable
    ... on Node {
      __isNode: __typename
      id
    }
  }
}

fragment EventTimeAndRecurrence_event on Event {
  isAllDay
  startTime {
    type
    dateOrDateTime
    timeZone
    millis
    offsetMinutes
  }
  endTime {
    type
    dateOrDateTime
    timeZone
    millis
    offsetMinutes
  }
  eventKey {
    externalEventId
    id
  }
  eventFlexibilityErrorable {
    __typename
    ... on EventFlexibilityNewList {
      list {
        flex
        flexString
      }
    }
  }
  recurrenceRules {
    firstInstanceStartTime {
      type
      dateOrDateTime
      timeZone
      millis
      offsetMinutes
    }
    timeZone
    interval {
      interval
      byDay
      bySetPos
      freqType
      count
      untilTime {
        type
        dateOrDateTime
        timeZone
        millis
        offsetMinutes
      }
    }
  }
  annotatedEvent {
    orgTags {
      tag
      state {
        active
        value
        subjectType
      }
    }
    id
  }
}

fragment OrganizerAutopilotPausedFreemiumCallout_event on Event {
  eventParentRelayId
  organizer {
    urnValue
  }
}

fragment TutorialTeamSharedCalendar_flagsErrorable on FlagsErrorable {
  __isFlagsErrorable: __typename
  __typename
  ... on Flags {
    flags
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "calendarId"
    } as any, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "eventParentRelayId"
    } as any, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "orgRelayId"
    } as any, v3 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "orgRelayId"
        } as any
    ], v4 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "eventParentRelayId"
        } as any
    ], v5 = [
        {
            "kind": "Variable",
            "name": "calendarId",
            "variableName": "calendarId"
        } as any
    ], v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v8 = {
        "kind": "InlineFragment",
        "selections": [
            (v7 /*: any*/)
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    } as any, v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "value",
        "storageKey": null
    } as any, v10 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isYou",
        "storageKey": null
    } as any, v11 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "userId",
        "storageKey": null
    } as any, v12 = {
        "alias": null,
        "args": null,
        "concreteType": "UserProfile",
        "kind": "LinkedField",
        "name": "profile",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "givenName",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "familyName",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "externalImageUrl",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any, v13 = [
        {
            "alias": null,
            "args": null,
            "concreteType": "OrgPerson",
            "kind": "LinkedField",
            "name": "person",
            "plural": false,
            "selections": [
                (v6 /*: any*/),
                (v7 /*: any*/),
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "primaryCalendarId",
                    "storageKey": null
                },
                (v10 /*: any*/),
                (v11 /*: any*/),
                (v12 /*: any*/)
            ],
            "storageKey": null
        } as any
    ], v14 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "externalEventId",
        "storageKey": null
    } as any, v15 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "emails",
        "storageKey": null
    } as any, v16 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "calendarIds",
        "storageKey": null
    } as any, v17 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "tag",
        "storageKey": null
    } as any, v18 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "active",
        "storageKey": null
    } as any, v19 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "subjectType",
        "storageKey": null
    } as any, v20 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "subjectValue",
        "storageKey": null
    } as any, v21 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastModified",
        "storageKey": null
    } as any, v22 = {
        "alias": null,
        "args": null,
        "concreteType": "OrgTag",
        "kind": "LinkedField",
        "name": "orgTags",
        "plural": true,
        "selections": [
            (v17 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "TagState",
                "kind": "LinkedField",
                "name": "state",
                "plural": false,
                "selections": [
                    (v18 /*: any*/),
                    (v9 /*: any*/),
                    (v19 /*: any*/),
                    (v20 /*: any*/),
                    (v21 /*: any*/)
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any, v23 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dayOffset",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timeSlot",
            "storageKey": null
        } as any
    ], v24 = [
        {
            "alias": null,
            "args": null,
            "concreteType": "DayOffsetTimeSlot",
            "kind": "LinkedField",
            "name": "minSlot",
            "plural": false,
            "selections": (v23 /*: any*/),
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "concreteType": "DayOffsetTimeSlot",
            "kind": "LinkedField",
            "name": "maxSlot",
            "plural": false,
            "selections": (v23 /*: any*/),
            "storageKey": null
        } as any
    ], v25 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
    } as any, v26 = {
        "kind": "InlineFragment",
        "selections": [
            (v25 /*: any*/)
        ],
        "type": "GraphEntityError",
        "abstractKey": null
    } as any, v27 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "urnValue",
        "storageKey": null
    } as any, v28 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "dateOrDateTime",
        "storageKey": null
    } as any, v29 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "millis",
        "storageKey": null
    } as any, v30 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "type",
        "storageKey": null
    } as any, v31 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "timeZone",
        "storageKey": null
    } as any, v32 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "offsetMinutes",
        "storageKey": null
    } as any, v33 = [
        (v30 /*: any*/),
        (v28 /*: any*/),
        (v31 /*: any*/),
        (v29 /*: any*/),
        (v32 /*: any*/)
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                (v0 /*: any*/),
                (v1 /*: any*/),
                (v2 /*: any*/)
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "EventTeamQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "EventTeam_user"
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": "org",
                    "args": (v3 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "EventTeam_org"
                                }
                            ],
                            "type": "Org",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": "eventParent",
                    "args": (v4 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": (v5 /*: any*/),
                                    "kind": "FragmentSpread",
                                    "name": "EventTeam_eventParent"
                                }
                            ],
                            "type": "EventParent",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                (v2 /*: any*/),
                (v1 /*: any*/),
                (v0 /*: any*/)
            ],
            "kind": "Operation",
            "name": "EventTeamQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "chromeExtensionFlagsErrorable",
                                    "plural": false,
                                    "selections": [
                                        (v6 /*: any*/),
                                        {
                                            "kind": "TypeDiscriminator",
                                            "abstractKey": "__isFlagsErrorable"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "flags",
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "Flags",
                                            "abstractKey": null
                                        },
                                        (v8 /*: any*/)
                                    ],
                                    "storageKey": null
                                },
                                (v7 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        (v7 /*: any*/)
                    ],
                    "storageKey": null
                },
                {
                    "alias": "org",
                    "args": (v3 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        (v6 /*: any*/),
                        (v7 /*: any*/),
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "primaryOrgCalendar",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "experiments",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "domains",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "userTeams",
                                    "plural": false,
                                    "selections": [
                                        (v6 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Team",
                                                    "kind": "LinkedField",
                                                    "name": "list",
                                                    "plural": true,
                                                    "selections": [
                                                        (v7 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "teamId",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "teamCalendarId",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "teamName",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "Urn",
                                                            "kind": "LinkedField",
                                                            "name": "createdBy",
                                                            "plural": false,
                                                            "selections": [
                                                                (v9 /*: any*/),
                                                                (v7 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "TeamMember",
                                                            "kind": "LinkedField",
                                                            "name": "teamMembers",
                                                            "plural": true,
                                                            "selections": (v13 /*: any*/),
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "TeamMember",
                                                            "kind": "LinkedField",
                                                            "name": "invitedMembers",
                                                            "plural": true,
                                                            "selections": (v13 /*: any*/),
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "settings",
                                                            "plural": false,
                                                            "selections": [
                                                                (v6 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "manageTeamCalendar",
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "TeamSettings",
                                                                    "abstractKey": null
                                                                },
                                                                (v8 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "TeamList",
                                            "abstractKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "type": "Org",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": "eventParent",
                    "args": (v4 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        (v6 /*: any*/),
                        (v7 /*: any*/),
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                (v14 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Event",
                                    "kind": "LinkedField",
                                    "name": "events",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "eventParentRelayId",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "attendeePeople",
                                            "plural": false,
                                            "selections": [
                                                (v6 /*: any*/),
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "Person",
                                                            "kind": "LinkedField",
                                                            "name": "list",
                                                            "plural": true,
                                                            "selections": [
                                                                (v7 /*: any*/),
                                                                (v15 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "primaryEmail",
                                                                    "storageKey": null
                                                                },
                                                                (v12 /*: any*/),
                                                                (v10 /*: any*/),
                                                                (v6 /*: any*/),
                                                                (v11 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "isUser",
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "type": "PersonList",
                                                    "abstractKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "EventKey",
                                            "kind": "LinkedField",
                                            "name": "eventKey",
                                            "plural": false,
                                            "selections": [
                                                (v7 /*: any*/),
                                                (v14 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "orgId",
                                                    "storageKey": null
                                                },
                                                (v16 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "hashedCalendars",
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "AnnotatedEvent",
                                            "kind": "LinkedField",
                                            "name": "annotatedEvent",
                                            "plural": false,
                                            "selections": [
                                                (v22 /*: any*/),
                                                (v7 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "UserTag",
                                                    "kind": "LinkedField",
                                                    "name": "userTags",
                                                    "plural": true,
                                                    "selections": [
                                                        (v17 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "TagState",
                                                            "kind": "LinkedField",
                                                            "name": "states",
                                                            "plural": true,
                                                            "selections": [
                                                                (v9 /*: any*/),
                                                                (v19 /*: any*/),
                                                                (v20 /*: any*/),
                                                                (v21 /*: any*/),
                                                                (v18 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "AnnotatedEvent",
                                            "kind": "LinkedField",
                                            "name": "annotatedRecurringEvent",
                                            "plural": false,
                                            "selections": [
                                                (v22 /*: any*/),
                                                (v7 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "suggestedAutopilotSettingsResponseV3",
                                            "plural": false,
                                            "selections": [
                                                (v6 /*: any*/),
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "DayOffsetTimeSlotRange",
                                                            "kind": "LinkedField",
                                                            "name": "intersectionOfAttendeesMeetingHours",
                                                            "plural": false,
                                                            "selections": (v24 /*: any*/),
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "SuggestedAutotpilotSettingsResponseV3CalendarIdMeetingHours",
                                                            "kind": "LinkedField",
                                                            "name": "calendarIdToMeetingHours",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "calendarId",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "DayOffsetTimeSlotRange",
                                                                    "kind": "LinkedField",
                                                                    "name": "dayOffsetTimeSlotRanges",
                                                                    "plural": true,
                                                                    "selections": (v24 /*: any*/),
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "SuggestedAutopilotSettingsV3",
                                                            "kind": "LinkedField",
                                                            "name": "suggestedAutopilotSettings",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "isRoomFlexible",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "movementType",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "DayOffsetTimeSlot",
                                                                    "kind": "LinkedField",
                                                                    "name": "allowedEndTime",
                                                                    "plural": false,
                                                                    "selections": (v23 /*: any*/),
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "DayOffsetTimeSlot",
                                                                    "kind": "LinkedField",
                                                                    "name": "allowedStartTime",
                                                                    "plural": false,
                                                                    "selections": (v23 /*: any*/),
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "type": "SuggestedAutopilotSettingsResponseV3",
                                                    "abstractKey": null
                                                },
                                                (v26 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "moveRangeInLocalTimeV3",
                                            "plural": false,
                                            "selections": [
                                                (v6 /*: any*/),
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "DayOffsetTimeSlot",
                                                            "kind": "LinkedField",
                                                            "name": "allowedStartTimeInclusive",
                                                            "plural": false,
                                                            "selections": (v23 /*: any*/),
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "DayOffsetTimeSlot",
                                                            "kind": "LinkedField",
                                                            "name": "allowedEndTimeInclusive",
                                                            "plural": false,
                                                            "selections": (v23 /*: any*/),
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "type": "MoveRangeInLocalTimeV3",
                                                    "abstractKey": null
                                                },
                                                (v26 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Attendee",
                                            "kind": "LinkedField",
                                            "name": "organizer",
                                            "plural": false,
                                            "selections": [
                                                (v27 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": (v5 /*: any*/),
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "autopilotEventStatus",
                                            "plural": false,
                                            "selections": [
                                                (v6 /*: any*/),
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "status",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "type": "AutopilotEventStatus",
                                                    "abstractKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "featureStatesForOrganizer",
                                            "plural": false,
                                            "selections": [
                                                (v6 /*: any*/),
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "MixedFreemiumOrgUiState",
                                                            "kind": "LinkedField",
                                                            "name": "mixedFreemiumOrgUIState",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "autopilotPaused",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "moveRangesEnabled",
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "type": "FeatureStates",
                                                    "abstractKey": null
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "statusCode",
                                                            "storageKey": null
                                                        },
                                                        (v25 /*: any*/)
                                                    ],
                                                    "type": "GraphEntityError",
                                                    "abstractKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "title",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "isAllDay",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "locked",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "EventTime",
                                            "kind": "LinkedField",
                                            "name": "startTime",
                                            "plural": false,
                                            "selections": [
                                                (v28 /*: any*/),
                                                (v29 /*: any*/),
                                                (v30 /*: any*/),
                                                (v31 /*: any*/),
                                                (v32 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Attendee",
                                            "kind": "LinkedField",
                                            "name": "attendees",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "displayName",
                                                    "storageKey": null
                                                },
                                                (v27 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "organizer",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "responseStatus",
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "isClockwiseEvent",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "transparency",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "EventTime",
                                            "kind": "LinkedField",
                                            "name": "endTime",
                                            "plural": false,
                                            "selections": (v33 /*: any*/),
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "eventFlexibilityErrorable",
                                            "plural": false,
                                            "selections": [
                                                (v6 /*: any*/),
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "EventFlexibilityNew",
                                                            "kind": "LinkedField",
                                                            "name": "list",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "flex",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "flexString",
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "type": "EventFlexibilityNewList",
                                                    "abstractKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "RecurrenceRules",
                                            "kind": "LinkedField",
                                            "name": "recurrenceRules",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "EventTime",
                                                    "kind": "LinkedField",
                                                    "name": "firstInstanceStartTime",
                                                    "plural": false,
                                                    "selections": (v33 /*: any*/),
                                                    "storageKey": null
                                                },
                                                (v31 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "IntervalDefinition",
                                                    "kind": "LinkedField",
                                                    "name": "interval",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "interval",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "byDay",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "bySetPos",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "freqType",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "count",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "EventTime",
                                                            "kind": "LinkedField",
                                                            "name": "untilTime",
                                                            "plural": false,
                                                            "selections": (v33 /*: any*/),
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "description",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "descriptionOmitted",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "createdMillis",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "updatedMillis",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "hangoutLink",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "scrubbedEvent",
                                            "storageKey": null
                                        },
                                        (v16 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "organizerPerson",
                                            "plural": false,
                                            "selections": [
                                                (v6 /*: any*/),
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        (v15 /*: any*/)
                                                    ],
                                                    "type": "Person",
                                                    "abstractKey": null
                                                },
                                                (v8 /*: any*/)
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "type": "EventParent",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "0a3f9d0a683f42ca0e8c3ed22f1437b9",
            "id": null,
            "metadata": {},
            "name": "EventTeamQuery",
            "operationKind": "query",
            "text": "query EventTeamQuery(\n  $orgRelayId: ID!\n  $eventParentRelayId: ID!\n  $calendarId: String!\n) {\n  viewer {\n    user {\n      ...EventTeam_user\n      id\n    }\n    id\n  }\n  org: node(id: $orgRelayId) {\n    __typename\n    ... on Org {\n      ...EventTeam_org\n    }\n    id\n  }\n  eventParent: node(id: $eventParentRelayId) {\n    __typename\n    ... on EventParent {\n      ...EventTeam_eventParent_3GsBW\n    }\n    id\n  }\n}\n\nfragment AutopilotFlexibility_event on Event {\n  eventParentRelayId\n  attendeePeople {\n    __typename\n    ... on PersonList {\n      list {\n        id\n        emails\n        primaryEmail\n        profile {\n          givenName\n          familyName\n          externalImageUrl\n        }\n        isYou\n      }\n    }\n  }\n  eventKey {\n    id\n    externalEventId\n  }\n  annotatedEvent {\n    orgTags {\n      tag\n      state {\n        active\n        value\n        subjectType\n        subjectValue\n        lastModified\n      }\n    }\n    id\n  }\n  annotatedRecurringEvent {\n    orgTags {\n      tag\n      state {\n        active\n        value\n        subjectType\n        subjectValue\n        lastModified\n      }\n    }\n    id\n  }\n  suggestedAutopilotSettingsResponseV3 {\n    __typename\n    ... on SuggestedAutopilotSettingsResponseV3 {\n      intersectionOfAttendeesMeetingHours {\n        minSlot {\n          dayOffset\n          timeSlot\n        }\n        maxSlot {\n          dayOffset\n          timeSlot\n        }\n      }\n      calendarIdToMeetingHours {\n        calendarId\n        dayOffsetTimeSlotRanges {\n          minSlot {\n            dayOffset\n            timeSlot\n          }\n          maxSlot {\n            dayOffset\n            timeSlot\n          }\n        }\n      }\n      suggestedAutopilotSettings {\n        isRoomFlexible\n        movementType\n        allowedEndTime {\n          dayOffset\n          timeSlot\n        }\n        allowedStartTime {\n          dayOffset\n          timeSlot\n        }\n      }\n    }\n    ... on GraphEntityError {\n      message\n    }\n  }\n  moveRangeInLocalTimeV3 {\n    __typename\n    ... on MoveRangeInLocalTimeV3 {\n      allowedStartTimeInclusive {\n        dayOffset\n        timeSlot\n      }\n      allowedEndTimeInclusive {\n        dayOffset\n        timeSlot\n      }\n    }\n    ... on GraphEntityError {\n      message\n    }\n  }\n}\n\nfragment AutopilotFormSaveOnEdit_event_3GsBW on Event {\n  ...AutopilotForm_event_3GsBW\n  title\n  isAllDay\n  locked\n  eventKey {\n    externalEventId\n    id\n  }\n  autopilotEventStatus(calendarId: $calendarId) {\n    __typename\n    ... on AutopilotEventStatus {\n      status\n    }\n  }\n  startTime {\n    dateOrDateTime\n    millis\n  }\n  organizer {\n    urnValue\n  }\n  attendees {\n    displayName\n    urnValue\n  }\n  annotatedEvent {\n    orgTags {\n      tag\n      state {\n        active\n        value\n        subjectType\n        subjectValue\n        lastModified\n      }\n    }\n    id\n  }\n  annotatedRecurringEvent {\n    orgTags {\n      tag\n      state {\n        active\n        value\n        subjectType\n        subjectValue\n        lastModified\n      }\n    }\n    id\n  }\n  attendeePeople {\n    __typename\n    ... on PersonList {\n      list {\n        id\n        emails\n        primaryEmail\n        profile {\n          givenName\n          familyName\n          externalImageUrl\n        }\n        isYou\n      }\n    }\n  }\n  suggestedAutopilotSettingsResponseV3 {\n    __typename\n    ... on SuggestedAutopilotSettingsResponseV3 {\n      intersectionOfAttendeesMeetingHours {\n        minSlot {\n          dayOffset\n          timeSlot\n        }\n        maxSlot {\n          dayOffset\n          timeSlot\n        }\n      }\n      calendarIdToMeetingHours {\n        calendarId\n        dayOffsetTimeSlotRanges {\n          minSlot {\n            dayOffset\n            timeSlot\n          }\n          maxSlot {\n            dayOffset\n            timeSlot\n          }\n        }\n      }\n      suggestedAutopilotSettings {\n        isRoomFlexible\n        movementType\n        allowedEndTime {\n          dayOffset\n          timeSlot\n        }\n        allowedStartTime {\n          dayOffset\n          timeSlot\n        }\n      }\n    }\n    ... on GraphEntityError {\n      message\n    }\n  }\n  moveRangeInLocalTimeV3 {\n    __typename\n    ... on MoveRangeInLocalTimeV3 {\n      allowedStartTimeInclusive {\n        dayOffset\n        timeSlot\n      }\n      allowedEndTimeInclusive {\n        dayOffset\n        timeSlot\n      }\n    }\n    ... on GraphEntityError {\n      message\n    }\n  }\n}\n\nfragment AutopilotForm_event_3GsBW on Event {\n  ...AutopilotFlexibility_event\n  ...OrganizerAutopilotPausedFreemiumCallout_event\n  eventParentRelayId\n  eventKey {\n    id\n    externalEventId\n  }\n  autopilotEventStatus(calendarId: $calendarId) {\n    __typename\n    ... on AutopilotEventStatus {\n      status\n    }\n  }\n  annotatedEvent {\n    orgTags {\n      tag\n      state {\n        active\n        value\n        subjectType\n        subjectValue\n        lastModified\n      }\n    }\n    id\n  }\n  annotatedRecurringEvent {\n    orgTags {\n      tag\n      state {\n        active\n        value\n        subjectType\n        subjectValue\n        lastModified\n      }\n    }\n    id\n  }\n  suggestedAutopilotSettingsResponseV3 {\n    __typename\n    ... on SuggestedAutopilotSettingsResponseV3 {\n      intersectionOfAttendeesMeetingHours {\n        minSlot {\n          dayOffset\n          timeSlot\n        }\n        maxSlot {\n          dayOffset\n          timeSlot\n        }\n      }\n      calendarIdToMeetingHours {\n        calendarId\n        dayOffsetTimeSlotRanges {\n          minSlot {\n            dayOffset\n            timeSlot\n          }\n          maxSlot {\n            dayOffset\n            timeSlot\n          }\n        }\n      }\n      suggestedAutopilotSettings {\n        isRoomFlexible\n        movementType\n        allowedEndTime {\n          dayOffset\n          timeSlot\n        }\n        allowedStartTime {\n          dayOffset\n          timeSlot\n        }\n      }\n    }\n    ... on GraphEntityError {\n      message\n    }\n  }\n  moveRangeInLocalTimeV3 {\n    __typename\n    ... on MoveRangeInLocalTimeV3 {\n      allowedStartTimeInclusive {\n        dayOffset\n        timeSlot\n      }\n      allowedEndTimeInclusive {\n        dayOffset\n        timeSlot\n      }\n    }\n    ... on GraphEntityError {\n      message\n    }\n  }\n  featureStatesForOrganizer {\n    __typename\n    ... on FeatureStates {\n      mixedFreemiumOrgUIState {\n        autopilotPaused\n        moveRangesEnabled\n      }\n    }\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n  }\n}\n\nfragment EventPeople_event on Event {\n  organizer {\n    urnValue\n  }\n  attendees {\n    organizer\n    urnValue\n    responseStatus\n  }\n  attendeePeople {\n    __typename\n    ... on PersonList {\n      list {\n        __typename\n        id\n        emails\n        primaryEmail\n        isYou\n        userId\n        isUser\n        profile {\n          givenName\n          familyName\n          externalImageUrl\n        }\n      }\n    }\n  }\n}\n\nfragment EventSmartHoldInfo_event_3GsBW on Event {\n  ...EventSummary_event_3GsBW\n  title\n  isClockwiseEvent\n  organizer {\n    urnValue\n  }\n  eventKey {\n    externalEventId\n    id\n  }\n  annotatedEvent {\n    orgTags {\n      tag\n      state {\n        subjectType\n        subjectValue\n        value\n        active\n      }\n    }\n    id\n  }\n  startTime {\n    type\n    dateOrDateTime\n    timeZone\n    millis\n    offsetMinutes\n  }\n  endTime {\n    type\n    dateOrDateTime\n    timeZone\n    millis\n    offsetMinutes\n  }\n}\n\nfragment EventSummaryAutopilot_event_3GsBW on Event {\n  autopilotEventStatus(calendarId: $calendarId) {\n    __typename\n    ... on AutopilotEventStatus {\n      status\n    }\n  }\n  annotatedEvent {\n    orgTags {\n      tag\n      state {\n        active\n        value\n        subjectType\n      }\n    }\n    id\n  }\n  annotatedRecurringEvent {\n    orgTags {\n      tag\n      state {\n        active\n        value\n        subjectType\n      }\n    }\n    id\n  }\n  featureStatesForOrganizer {\n    __typename\n    ... on FeatureStates {\n      mixedFreemiumOrgUIState {\n        autopilotPaused\n        moveRangesEnabled\n      }\n    }\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n  }\n}\n\nfragment EventSummaryColorCategory_event on Event {\n  title\n  isClockwiseEvent\n  transparency\n  isAllDay\n  eventKey {\n    id\n    externalEventId\n    orgId\n  }\n  annotatedEvent {\n    userTags {\n      tag\n      states {\n        value\n        subjectType\n        subjectValue\n        lastModified\n        active\n      }\n    }\n    orgTags {\n      tag\n      state {\n        value\n        subjectType\n        subjectValue\n        lastModified\n        active\n      }\n    }\n    id\n  }\n}\n\nfragment EventSummaryRecurrence_event on Event {\n  isAllDay\n  startTime {\n    type\n    dateOrDateTime\n    timeZone\n    millis\n    offsetMinutes\n  }\n  endTime {\n    type\n    dateOrDateTime\n    timeZone\n    millis\n    offsetMinutes\n  }\n  eventKey {\n    externalEventId\n    id\n  }\n  eventFlexibilityErrorable {\n    __typename\n    ... on EventFlexibilityNewList {\n      list {\n        flex\n        flexString\n      }\n    }\n  }\n  recurrenceRules {\n    firstInstanceStartTime {\n      type\n      dateOrDateTime\n      timeZone\n      millis\n      offsetMinutes\n    }\n    timeZone\n    interval {\n      interval\n      byDay\n      bySetPos\n      freqType\n      count\n      untilTime {\n        type\n        dateOrDateTime\n        timeZone\n        millis\n        offsetMinutes\n      }\n    }\n  }\n  annotatedEvent {\n    orgTags {\n      tag\n      state {\n        active\n        value\n        subjectType\n      }\n    }\n    id\n  }\n}\n\nfragment EventSummaryRoom_attendees on Attendee {\n  displayName\n  urnValue\n}\n\nfragment EventSummaryTime_event on Event {\n  startTime {\n    type\n    dateOrDateTime\n    timeZone\n    millis\n    offsetMinutes\n  }\n  endTime {\n    type\n    dateOrDateTime\n    timeZone\n    millis\n    offsetMinutes\n  }\n  eventKey {\n    externalEventId\n    id\n  }\n  eventFlexibilityErrorable {\n    __typename\n    ... on EventFlexibilityNewList {\n      list {\n        flex\n        flexString\n      }\n    }\n  }\n  recurrenceRules {\n    firstInstanceStartTime {\n      type\n      dateOrDateTime\n      timeZone\n      millis\n      offsetMinutes\n    }\n    timeZone\n    interval {\n      interval\n      byDay\n      bySetPos\n      freqType\n      count\n      untilTime {\n        type\n        dateOrDateTime\n        timeZone\n        millis\n        offsetMinutes\n      }\n    }\n  }\n  annotatedEvent {\n    orgTags {\n      tag\n      state {\n        active\n        value\n        subjectType\n      }\n    }\n    id\n  }\n}\n\nfragment EventSummaryTime_org on Org {\n  id\n  primaryOrgCalendar\n}\n\nfragment EventSummary_event_3GsBW on Event {\n  ...EventSummaryColorCategory_event\n  ...EventSummaryRecurrence_event\n  ...EventSummaryTime_event\n  ...EventSummaryAutopilot_event_3GsBW\n  ...EventTimeAndRecurrence_event\n  ...AutopilotFormSaveOnEdit_event_3GsBW\n  title\n  isAllDay\n  description\n  descriptionOmitted\n  locked\n  isClockwiseEvent\n  createdMillis\n  updatedMillis\n  hangoutLink\n  scrubbedEvent\n  organizer {\n    urnValue\n  }\n  eventKey {\n    externalEventId\n    id\n  }\n  annotatedEvent {\n    orgTags {\n      tag\n      state {\n        subjectType\n        subjectValue\n        value\n        active\n      }\n    }\n    id\n  }\n  attendees {\n    ...EventSummaryRoom_attendees\n    organizer\n    displayName\n    urnValue\n  }\n  startTime {\n    millis\n  }\n  endTime {\n    millis\n  }\n  recurrenceRules {\n    firstInstanceStartTime {\n      type\n      dateOrDateTime\n      timeZone\n      millis\n      offsetMinutes\n    }\n    timeZone\n    interval {\n      interval\n      byDay\n      bySetPos\n      freqType\n      count\n      untilTime {\n        type\n        dateOrDateTime\n        timeZone\n        millis\n        offsetMinutes\n      }\n    }\n  }\n}\n\nfragment EventTeam_eventParent_3GsBW on EventParent {\n  id\n  externalEventId\n  events {\n    ...AutopilotFormSaveOnEdit_event_3GsBW\n    ...EventSummary_event_3GsBW\n    ...EventSmartHoldInfo_event_3GsBW\n    ...EventPeople_event\n    ...EventSummaryTime_event\n    calendarIds\n    isAllDay\n    isClockwiseEvent\n    locked\n    organizerPerson {\n      __typename\n      ... on Person {\n        emails\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    annotatedEvent {\n      userTags {\n        tag\n        states {\n          value\n          subjectType\n          subjectValue\n          lastModified\n          active\n        }\n      }\n      orgTags {\n        tag\n        state {\n          subjectType\n          subjectValue\n          value\n          active\n        }\n      }\n      id\n    }\n    eventKey {\n      id\n      calendarIds\n      externalEventId\n      hashedCalendars\n      orgId\n    }\n    startTime {\n      millis\n      dateOrDateTime\n      timeZone\n    }\n    endTime {\n      millis\n    }\n    title\n    attendees {\n      displayName\n      urnValue\n    }\n    organizer {\n      urnValue\n    }\n  }\n}\n\nfragment EventTeam_org on Org {\n  id\n  ...EventSummaryTime_org\n  experiments\n  domains\n  primaryOrgCalendar\n  userTeams {\n    __typename\n    ... on TeamList {\n      list {\n        id\n        teamId\n        teamCalendarId\n        teamName\n        createdBy {\n          value\n          id\n        }\n        teamMembers {\n          person {\n            __typename\n            id\n            primaryCalendarId\n            isYou\n            userId\n            profile {\n              givenName\n              familyName\n              externalImageUrl\n            }\n          }\n        }\n        invitedMembers {\n          person {\n            __typename\n            id\n            primaryCalendarId\n            isYou\n            userId\n            profile {\n              givenName\n              familyName\n              externalImageUrl\n            }\n          }\n        }\n        settings {\n          __typename\n          ... on TeamSettings {\n            manageTeamCalendar\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment EventTeam_user on User {\n  chromeExtensionFlagsErrorable {\n    __typename\n    ...TutorialTeamSharedCalendar_flagsErrorable\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment EventTimeAndRecurrence_event on Event {\n  isAllDay\n  startTime {\n    type\n    dateOrDateTime\n    timeZone\n    millis\n    offsetMinutes\n  }\n  endTime {\n    type\n    dateOrDateTime\n    timeZone\n    millis\n    offsetMinutes\n  }\n  eventKey {\n    externalEventId\n    id\n  }\n  eventFlexibilityErrorable {\n    __typename\n    ... on EventFlexibilityNewList {\n      list {\n        flex\n        flexString\n      }\n    }\n  }\n  recurrenceRules {\n    firstInstanceStartTime {\n      type\n      dateOrDateTime\n      timeZone\n      millis\n      offsetMinutes\n    }\n    timeZone\n    interval {\n      interval\n      byDay\n      bySetPos\n      freqType\n      count\n      untilTime {\n        type\n        dateOrDateTime\n        timeZone\n        millis\n        offsetMinutes\n      }\n    }\n  }\n  annotatedEvent {\n    orgTags {\n      tag\n      state {\n        active\n        value\n        subjectType\n      }\n    }\n    id\n  }\n}\n\nfragment OrganizerAutopilotPausedFreemiumCallout_event on Event {\n  eventParentRelayId\n  organizer {\n    urnValue\n  }\n}\n\nfragment TutorialTeamSharedCalendar_flagsErrorable on FlagsErrorable {\n  __isFlagsErrorable: __typename\n  __typename\n  ... on Flags {\n    flags\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = 'f65058648a9ddffb6f171e6a9a24e292';
export default node;
